import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Callback = () => {
  const navigate = useNavigate();
  const { handleCallback } = useAuth();

  useEffect(() => {
    const processCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');

      if (error) {
        console.error('OAuth error:', error);
        navigate('/login');
        return;
      }

      if (code) {
        try {
          await handleCallback(code);
          navigate('/');
        } catch (error) {
          console.error('Callback processing failed:', error);
          navigate('/login');
        }
      } else {
        navigate('/login');
      }
    };

    processCallback();
  }, [navigate, handleCallback]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '1.1rem',
      color: '#666'
    }}>
      Processing login...
    </div>
  );
};

export default Callback;
